import React from "react";
import { WindowChoose } from "..";

const WindowOption = (data) => {
  let career = false;
  let careerText = "Żadnej z usług dodatkowych";
  if (data.parsedData != null && (data.parsedData.offer != undefined || data.parsedData.offer != null)) {
    career = true;
    careerText = `Usługę dodatkową: ${data.careerName}`;

    console.log(data.calendarDate);
    if (!!data.calendarDate) {
      careerText += ` - ${data.calendarDate.localization ?? ''}`;
      careerText += ` Termin: ${formatDateTime(data.calendarDate.date_from)} - ${formatDateTime(data.calendarDate.date_to)}`;
    }
  }

  function formatDateTime(dateTimeString) {
    let data = new Date(dateTimeString);

    let year = data.getFullYear();
    let month = ("0" + (data.getMonth() + 1)).slice(-2);
    let day = ("0" + data.getDate()).slice(-2);
    let hour = ("0" + data.getHours()).slice(-2);
    let minute = ("0" + data.getMinutes()).slice(-2);

    let formated_date =
      year + "-" + month + "-" + day + " " + hour + ":" + minute;

    return formated_date;
  }

  const option = [
    {
      icon: data.fundingIcon,
      display:
        data.parsedData !== null &&
        data.parsedData.funding !== null &&
        data.parsedData.funding !== undefined &&
        data.parsedData.funding !== 0,
      text: data.fundingName,
    },
    { icon: data.careerIcon, display: career, text: careerText },
    {
      icon: data.serviceIcon,
      display:
        data.parsedData !== null &&
        data.parsedData.service !== null &&
        data.parsedData.service !== undefined &&
        data.parsedData.service !== 0,
      text: data.serviceName,
    },
  ];

  const allFalse = option.some((item) => item.display === true);
  const allTrue = option.some((item) => item.display === false);

  let indexSelected = 1;
  let indexNonSelected = 1;

  return (
    <>
      <div className="text-box summary-margin">
        {allFalse ? (
          <div className="title-box1">
            <div className="title-2 mb-4">Wybrałeś:</div>
          </div>
        ) : null}

        {option.map((object) =>
          object.display ? (
            <WindowChoose
              index={indexSelected++}
              icon={object.icon}
              text={object.text}
            />
          ) : null
        )}

        {allTrue ? (
          <div className="title-box1">
            <div className="title-2 mb-4">Nie wybrałeś:</div>
          </div>
        ) : null}

        {option.map((object) =>
          !object.display ? (
            <WindowChoose
              index={indexNonSelected++}
              icon={object.icon}
              text={object.text}
            />
          ) : null
        )}
      </div>
    </>
  );
};

export default WindowOption;
